<div #content *ngIf="Library">
  <div>
    <div *ngFor="let b of blankBarcodes" class="barcode-container">
      <reader-barcode
        [reader]="null"
        style="
          justify-content: center;
          display: flex;
          overflow: visible;
          box-sizing: border-box;
        "
      ></reader-barcode>
    </div>
    <div *ngFor="let r of Readers" class="barcode-container">
      <reader-barcode
        [reader]="r"
        style="
          justify-content: center;
          display: flex;
          overflow: visible;
          box-sizing: border-box;
        "
      ></reader-barcode>
    </div>
  </div>
</div>
